export default __webpack_public_path__ + "static/media/green-square-tick.b08fdd51.svg";